{
  "scripts": {
    "https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js": "sha384-4PjG0wAT5sk23cuuw1DQAcYke4+xHCdUXcQFxeqelj3U9amabGh3rGwtAWOPxPIR",
    "https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js": "sha384-VM96ZnWRJL1Ez7nVX13O5k0nAYPXEL56O5CZJgzmzo+UkXbnyQljUv07JTX9HiEf"
  }
}